import { render, staticRenderFns } from "./HistoryOperationsTab.vue?vue&type=template&id=3f7faba0&scoped=true"
import script from "./HistoryOperationsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryOperationsTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HistoryOperationsTab.vue?vue&type=style&index=0&id=3f7faba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7faba0",
  null
  
)

export default component.exports